// JsonViewer 用の純ロジック。React 非依存でユニットテスト可能。
// ハイライト / 折りたたみ判定用の型名を返す。
export function getValueType(value) {
    if (value === null)
        return 'null';
    if (value === undefined)
        return 'undefined';
    if (Array.isArray(value))
        return 'array';
    const t = typeof value;
    if (t === 'string')
        return 'string';
    if (t === 'number')
        return 'number';
    if (t === 'boolean')
        return 'boolean';
    // function / symbol / bigint / object はまとめて object 扱い
    return 'object';
}
// 循環参照があっても投げずに文字列化する。循環箇所は "[Circular]" に置換。
export function safeStringify(value, space = 2) {
    const seen = new WeakSet();
    try {
        const out = JSON.stringify(value, (_key, val) => {
            if (typeof val === 'object' && val !== null) {
                if (seen.has(val))
                    return '[Circular]';
                seen.add(val);
            }
            return val;
        }, space);
        // JSON.stringify(undefined) など結果が undefined の場合は文字列化する。
        return out === undefined ? String(value) : out;
    }
    catch {
        return String(value);
    }
}
